module.exports = __webpack_public_path__ + "static/media/cubahaus.6907f09e.png";